import type { MouseEvent } from 'react';

/**
 * Bridge-first dialer helper.
 *
 * Plain `<a href="tel:...">` is unreliable inside the Android Flutter WebView —
 * taps can hit the WebView's own `ERR_UNKNOWN_URL_SCHEME` page before the
 * native NavigationDelegate intercepts. Pair this click handler with the
 * anchor `href` so the bridge handles native shell taps and the `href`
 * remains a fallback for browsers.
 */

/**
 * Reduce to digits and prepend the country code for a bare 10-digit Indian
 * mobile, so numbers stored with and without "91" dial identically.
 */
const normalizePhone = (raw?: string): string => {
    const d = (raw ?? '').replace(/\D/g, '');
    if (d.length === 10) return `91${d}`;
    return d;
};

export const formatMobile = (raw?: string): string => {
    const d = (raw ?? '').replace(/\D/g, '');
    if (d.length === 12 && d.startsWith('91')) return d.slice(2);
    if (d.length === 10) return d;
    return raw ?? '';
};

export const telHref = (raw?: string) => {
    const p = normalizePhone(raw);
    return p ? `tel:${p}` : undefined;
};

export const dial = (e: MouseEvent, raw?: string) => {
    e.stopPropagation();
    const phone = normalizePhone(raw);
    if (!phone) return;
    const w = window as any;
    const channel = w.ReactNativeWebView ?? w.WebViewChannel;
    if (channel?.postMessage) {
        try {
            channel.postMessage(JSON.stringify({ action: 'openDialer', payload: { phone } }));
            e.preventDefault();
        } catch {}
    }
};
